import { create } from 'zustand';

interface LoadingProgress {
  isLoading: boolean;
  setIsLoading: (isLoading: boolean) => void;
}

export const useLoadingProgress = create<LoadingProgress>((set) => ({
  isLoading: false,
  setIsLoading: (isLoading: boolean) => set({ isLoading }),
}));
